<template>
  <div class="card custom-card border-0 mt-4 p-0" @click="preview(obj.id)">
    <div class="row g-0 h-100">
      <div class="col-12 col-md-6 h-100 p-0">
        <b-skeleton-img 
          v-if="!coverImageSrc" 
          no-aspect 
          height="100%" 
          width="100%"
        ></b-skeleton-img>
        
        <img 
          v-else 
          class="image" 
          :src="coverImageSrc"
        >
      </div>

      <div class="col-12 col-md-6 p-4">
        <div class="titulo">
          <b-skeleton v-if="!obj.title" width="90%"></b-skeleton>
          <template v-else>{{ obj.title }}</template>
        </div>

        <div class="badges-group">
          <template v-if="!obj.id"> <b-skeleton type="button" width="60px" height="20px"></b-skeleton>
            <b-skeleton width="80px"></b-skeleton>
          </template>
          
          <template v-else>
            <div class="badge-categoria" v-if="obj.category">
              {{ resolveEnum(obj.category) }}
            </div>
            <div class="obrigatorio" v-if="obj.mandatoryReading">
              Obrigatório
            </div>
            <div class="data">
              {{ obj.contentDate }}
            </div>
          </template>
        </div>

        <div class="conteudo">
          <template v-if="!obj.coverCallout">
            <b-skeleton width="100%"></b-skeleton>
            <b-skeleton width="100%"></b-skeleton>
            <b-skeleton width="60%"></b-skeleton>
          </template>
          <template v-else>
            {{ obj.coverCallout }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoutesPaths from '../../../router/router-structure/routes-paths';
import coverImageMixin from '../mixins/coverImageMixin';


export default {
  name: 'NewsHighlights',
  mixins: [coverImageMixin],
  props: {
    obj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      coverImageSrc: null,
    };
  },
  watch: {
    obj: {
      immediate: true,
      async handler(newObj) {
        this._revokeCoverImages();
        this.coverImageSrc = null;
        if (newObj?.coverImageUrl) {
          this.coverImageSrc = await this.loadCoverImage(newObj.coverImageUrl);
        }
      },
    },
  },
  methods: {
    resolveEnum(enumValue) {
      switch (enumValue) {
        case "1":
          return "Artigos";
        case "2":
          return "Comunicados";
        case "3":
          return "Eventos";
        case "4":
          return "Manuais";
        case "5":
          return "Noticias";
        case "6":
          return "Oportunidades";
        case "7":
          return "Treinamentos";
      }
    },
    preview(id) {
      this.$router.push({
        path: RoutesPaths.connection.preview(id)
      });
    }
  },
}

</script>

<style scoped>
.custom-card {
  min-height: 170px;
  height: auto; 
  overflow: hidden;
  cursor: pointer;
}

.image {
  width: 100%;
  height: 200px; /* Definimos uma altura para a imagem não sumir no mobile */
  object-fit: cover;
  display: block;
}

@media (min-width: 768px) {
  .custom-card {
    height: 170px; /* Volta para a altura fixa apenas no desktop */
  }
  .image {
    height: 100%; /* No desktop ela volta a preencher a altura do card */
  }
}

.titulo {
  color: #343A40;
  font-family: "Trebuchet MS";
  font-size: 16px;
}

.conteudo {
  color: #343A40;
  font-family: "Trebuchet MS";
  font-size: 12px;
  margin-top: 10px;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-categoria {
  border-radius: 40px;
  background: #F4F6F6;
  padding: 3px 5px;
  color: #212529;
  font-family: "Trebuchet MS";
  font-size: 12px;
  margin-top: 10px;
  width: fit-content;
}

.obrigatorio {
  border-radius: 40px;
  background: #C0DB6D;
  padding: 3px 5px;
  color: #0E4025;
  font-family: "Trebuchet MS";
  font-size: 12px;
  width: fit-content;
}

.badges-group {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  align-items: center;
}

.badge-categoria,
.obrigatorio {
  margin-top: 0;
}

.data {
  color: #7A7E83;
  font-family: "Trebuchet MS";
  font-size: 12px;
}
</style>